module.exports = __webpack_public_path__ + "static/img/newsimg1.c7b4efb5.jpg";